import React from "react";
import MunicipalityMap, {
  MapMunicipality,
  municipalityUrl,
} from "./MunicipalityMap";
import { formatNumber } from "../../state/BreaksCampaignContext";

export interface MunicipalityStatistics extends MapMunicipality {
  classes: number;
  completedBreaks: number;
}

interface MunicipalityMapSectionProps {
  heading: string;
  municipalities: MunicipalityStatistics[];
  totalMunicipalities: number;
  breaksThisWeek: number;
  /** Tom när kampanjstartsidan saknar statistiksida. */
  statisticsUrl: string;
}

function overviewText(
  represented: number,
  total: number,
  breaksThisWeek: number,
): string {
  const text = `${formatNumber(represented)} av Sveriges ${formatNumber(total)} kommuner är representerade.`;
  if (breaksThisWeek <= 0) return text;

  return breaksThisWeek === 1
    ? `${text} Den här veckan har 1 nytt Break genomförts.`
    : `${text} Den här veckan har ${formatNumber(breaksThisWeek)} nya Breaks genomförts.`;
}

function municipalityText({
  name,
  classes,
  completedBreaks,
}: MunicipalityStatistics): string {
  const classLabel = classes === 1 ? "klass" : "klasser";
  const breakLabel =
    completedBreaks === 1 ? "genomfört Break" : "genomförda Breaks";
  return `${name}: ${formatNumber(classes)} ${classLabel} och ${formatNumber(completedBreaks)} ${breakLabel}.`;
}

export default function MunicipalityMapSection({
  heading,
  municipalities,
  totalMunicipalities,
  breaksThisWeek,
  statisticsUrl,
}: MunicipalityMapSectionProps): React.JSX.Element {
  const [selectedCode, setSelectedCode] = React.useState("");
  const selected = municipalities.find((m) => m.code === selectedCode);

  return (
    <div className="row gy-5 gx-xl-5 align-items-center">
      <div className="col-lg-6">
        <MunicipalityMap
          municipalities={municipalities}
          statisticsUrl={statisticsUrl}
          selectedCode={selectedCode}
        />
      </div>
      <div className="col-lg-6">
        {heading && <h2 className="mb-3">{heading}</h2>}
        <p className="breaks-lead mb-4" aria-live="polite">
          {selected
            ? municipalityText(selected)
            : overviewText(
                municipalities.length,
                totalMunicipalities,
                breaksThisWeek,
              )}
        </p>
        {municipalities.length > 0 && (
          <div className="breaks-map__form">
            <label
              className="form-label visually-hidden"
              htmlFor="breaks-map-municipality"
            >
              Din kommun
            </label>
            <div className="d-flex flex-wrap align-items-center gap-3">
              <select
                className="form-select breaks-map__select"
                id="breaks-map-municipality"
                value={selectedCode}
                onChange={(event) => setSelectedCode(event.target.value)}
              >
                <option value="">Välj kommun</option>
                {municipalities.map(({ code, name }) => (
                  <option key={code} value={code}>
                    {name}
                  </option>
                ))}
              </select>
              {selected && statisticsUrl && (
                <a
                  className="btn btn-secondary"
                  href={municipalityUrl(statisticsUrl, selected.code)}
                >
                  Se all statistik för {selected.name}
                </a>
              )}
            </div>
          </div>
        )}
      </div>
    </div>
  );
}
